export default "__VITE_ASSET__CiltjsXd__"